import { Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { Logo } from './Logo'
import { Footer } from './Footer'

interface PublicPageShellProps {
  children: React.ReactNode
  backTo?: string
  backLabel?: string
}

/** Cabecera (logo + volver) + contenido + footer, para páginas públicas sueltas. */
export function PublicPageShell({ children, backTo = '/', backLabel = 'Volver al inicio' }: PublicPageShellProps) {
  return (
    <div className="flex min-h-screen flex-col bg-white">
      <header className="sticky top-0 z-30 border-b border-black/5 bg-white/90 backdrop-blur">
        <div className="mx-auto flex max-w-5xl items-center justify-between px-5 py-4 lg:px-6">
          <Link to="/" className="inline-flex items-center">
            <Logo />
          </Link>
          <Link to={backTo} className="inline-flex items-center gap-1.5 text-sm font-medium text-muted-foreground hover:text-foreground">
            <ArrowLeft className="size-4" /> {backLabel}
          </Link>
        </div>
      </header>
      <main className="mx-auto w-full max-w-5xl flex-1 px-5 py-12 lg:px-6 lg:py-16">{children}</main>
      <Footer />
    </div>
  )
}
